import { render, staticRenderFns } from "./EventScreenshotDialog.vue?vue&type=template&id=af51a35a"
import script from "./EventScreenshotDialog.vue?vue&type=script&lang=js"
export * from "./EventScreenshotDialog.vue?vue&type=script&lang=js"
import style0 from "./EventScreenshotDialog.vue?vue&type=style&index=0&id=af51a35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports